import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['file'])
  },
  watch: {
    file: {
      handler(newValue){
        if (newValue) {
          this.convertToFile(newValue);
        }
      },
      // immediate: true
    }
  },
  methods: {
    ...mapActions(['setFile']),
    previewFile($event) {
      let input = $event.target;
      if (input.files?.[0]) {
        // create a new FileReader
        let reader = new FileReader();
        let fileName = input.files[0].name;

        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Read result and set url in setFileUr
          let result = e.target.result.replace(/^data:application\/(pdf|doc);base64,/, "");
          let obj = { name: fileName, url: result };
          this.setFile(obj);
          console.log(this.file);
        }
        // Start the reader job - read file as a data url
        reader.readAsDataURL(input.files[0]);
      }
    },
    convertToFile(obj) {
      let url = `data:application/pdf;base64,${obj.url}`;

      // convert url file to blob
      fetch(url)
      .then(res => res.blob())
      .then(data => {
        console.log('DATA FILE', data);
        // set file in category file
        this.$emit('changeFile', obj.name, data);
      })
    },
    clearInputFile() {
      this.$refs.fileupload.value = null;
      this.setFile(null);
      this.$emit('changeFile', null);
    }
  },
}
